import { UniversalProduct } from '@1po/1po-bff-fe-spec/generated/catalog/universal_products/response/GetUniversalProductsResponse';
import { UniversalProductReference } from './Catalog.types';

export const convertUniversalProductToUniversalProductReference = (
  product: UniversalProduct | undefined,
): UniversalProductReference | undefined => {
  return product
    ? {
        brand: product.brandName,
        name: product.productName,
        referenceNumber: product.referenceNumber,
      }
    : undefined;
};
